import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { enumItems } from './enumItems';
import { SPNumberField } from '../components/Table/fields/SPNumberField';

export const serviceProviderVehicle: SchemaWithClient<any> = {
  name: 'Service Provider - Vehicle',
  pluralName: 'Service Provider - Vehicle',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceProvider
      ),
      switchboard: true,
      url: enumItems.serviceProvider.client.getAllPath,
      tempSchema: enumItems.serviceProvider,
      readOnly: true,
    },
    vehicle: {
      name: 'Vehicle',
      fieldRenderer: SelectField.tableAdapter(enumItems.vehicle),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.vehicle),
      switchboard: true,
      url: enumItems.vehicle.client.getAllPath,
      tempSchema: enumItems.vehicle,
      required: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      hide: true,
    },
  },
  client: new Client('/service-provider-vehicle'),
};
